function setEqualSlideHeights() {
  let maxHeight = 0;

  // Reset all slide content heights before recalculating
  $(".testimonial-slider .cust-testi-wraper").css("height", "auto");

  // Find max height among all slides' .cust-testi-wraper elements (including clones)
  $(".testimonial-slider .slick-slide").each(function () {
    const box = $(this).find(".cust-testi-wraper");
    if (box.length) {
      const h = box.outerHeight();
      if (h > maxHeight) maxHeight = h;
    }
  });
  // console.log(`Max height to set: ${maxHeight}px`);

  // Set all .cust-testi-wraper heights to maxHeight
  $(".testimonial-slider .cust-testi-wraper").css("height", maxHeight + "px");
}

// Run height adjustment on slider init, after each reposition, and window resize
$(".testimonial-slider").on("init", function () {
  setEqualSlideHeights();
});
$(".testimonial-slider").on("setPosition", function () {
  setEqualSlideHeights();
});
$(window).on("resize", function () {
  setEqualSlideHeights();
});

$(".testimonial-slider").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: true, 
  arrows: false,
  prevArrow: '<button class="slick-prev custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0619/5960/2238/files/right-md_577b6a33-36b0-4863-b598-d634ccf2ea12.png?v=1747206583"></button>',
  nextArrow: '<button class="slick-next custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0619/5960/2238/files/right-md.png?v=1747206574"></button>',
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        dots: false, 
        arrows: false
      }
    }
  ]
});